export const email = 'email address';
export const lastName = 'last name';
export const phoneNumber = 'phone number';
export const shippingAddress = 'shipping address';
export const companyInfo = 'company info';
export const orderNote = 'order note';
export const fullName = 'full name';

export const typesArray = [email, lastName, phoneNumber, shippingAddress, companyInfo, orderNote];
